<span class='workflowStepState'><i [attr.class]="cssClass" aria-hidden="true"></i></span>
